import React from 'react'
import { CanvasMessageCard } from './CanvasMessageCard'
import type { CanvasItem } from './message'

export interface CanvasCardsContainerProps {
  canvasItems: CanvasItem[]
  onItemClick?: (canvas: CanvasItem, index: number) => void
}

/**
 * Container for displaying canvas cards below assistant messages.
 * Follows similar styling patterns as MessageUploadCardsContainer.
 * Figma specs: Left-aligned (assistant side), 3 cards per row max, 8px gap, flex-wrap.
 */
export const CanvasCardsContainer: React.FC<CanvasCardsContainerProps> = ({
  canvasItems,
  onItemClick
}) => {
  if (!canvasItems || canvasItems.length === 0) {
    return null
  }

  return (
    <div
      className='flex flex-wrap justify-start'
      style={{
        gap: '8px',
        maxWidth: '720px'
      }}
    >
      {canvasItems.map((canvas, index) => (
        <CanvasMessageCard
          key={`canvas-${index}-${canvas.title}`}
          canvas={canvas}
          onClick={() => onItemClick?.(canvas, index)}
        />
      ))}
    </div>
  )
}

export default CanvasCardsContainer
